// Import CSS
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap CSS
import 'bootstrap-icons/font/bootstrap-icons.css'; // Bootstrap Icons CSS
import 'toastr/build/toastr.min.css'; // Toastr CSS
import 'select2/dist/css/select2.min.css'; // Select2 CSS
import 'sweetalert2/dist/sweetalert2.min.css'; // SweetAlert2 CSS
import '@fortawesome/fontawesome-free/css/all.min.css'; // Font Awesome CSS
import 'flatpickr/dist/flatpickr.min.css'; // Flatpickr CSS
import 'summernote/dist/summernote-bs5.min.css'; // Summernote CSS